import { SaveOutlined, CloudUploadOutlined, LoadingOutlined } from '@ant-design/icons'
import { Col, Row, List, Button, Spin, Modal, Upload, Alert } from 'antd'
import * as React from 'react'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import { ImportFattureElettronicaModel } from '../../models/ImportFattureElettronicaModel'
import { RcFile } from 'antd/es/upload/interface'
import { RouteComponentProps, withRouter } from 'react-router'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { ai } from '../../TelemetryService'

const { Dragger } = Upload


class PageImportManualiState extends ImportFattureElettronicaModel {
    isLoading: boolean
    showAlert: boolean
}

export class PageImportFEManualiComp extends React.Component<RouteComponentProps, PageImportManualiState> {
    service: IConfigurazioneService
    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.CONFIGURAZIONE_SERVICE)
        this.state = new PageImportManualiState()
    }

    async componentDidMount() {
        this.loadConfig();
    }

    async loadConfig() {

        this.setState({ isLoading: false })
    }


    onImportClick = async () => {
        this.setState({ ...this.state, isLoading: true })
        debugger
        var rs = await this.service.ImportazioneFattureManuale(this.state)
        var showAlert = rs.IsValid
        this.setState({ ...rs, Files: null, isLoading: false, showAlert: showAlert })
    }



    render() {
        return (
            <>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} spin />} spinning={this.state.isLoading}>

                    <Row>
                        <Col offset={22} span={2}>
                            <Button type="default" key="save" icon={<CloudUploadOutlined />} onClick={() => this.onImportClick()}>Importa</Button>
                        </Col>
                    </Row>
                    {this.state.showAlert ?
                        (<>
                            <br />
                            <Row>
                                <Col span={24}>

                                    <Alert type="success"
                                        showIcon
                                        message={`Importazione fatture elettroniche terminata`}
                                        description={
                                            this.state.Inizio != "" ?
                                                <div>
                                                    <span> Il fatturato è stato calcolato sul periodo {this.state.Inizio} - {this.state.Fine}.</span>
                                                    <br />
                                                    <span>Accedi alla tab "Raccolta dati" per i dettagli nei mesi specifici</span>
                                                </div> :
                                                <div>
                                                    <span> Le fatture importate non erano di vendita. Il fatturato non è stato aggiornato</span>
                                                </div>
                                        }
                                    />
                                </Col>
                            </Row>
                            <br />
                        </>) : (<br />)
                    }
                    <Row>
                        <Col span={24}>
                            <Dragger
                                multiple={true}
                                showUploadList={true}
                                fileList={this.state.Files ? this.state.Files as Array<RcFile> : []}
                                beforeUpload={(file, fileList) => { this.setState({ Files: fileList }); return false }}
                            >

                                <p className="ant-upload-text">Clicca o trascina i file in quest'area per caricarlo</p>
                            </Dragger>
                        </Col>
                    </Row>
                </Spin>
            </>
        )
    }
}

export const PageImportFEManuali = withRouter(withAITracking(ai.reactPlugin, PageImportFEManualiComp, "PageImportFEManuali"))
